import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./Auth/AuthConfig";
import { Provider } from "react-redux";
import store from "./Redux/Store";
import { UserProvider } from "./Context/UserContext";
import { ShareholderProvider } from "./Context/ShareholderContext";

const pca = new PublicClientApplication(msalConfig);

async function bootstrap() {
  try {
    await pca.initialize();

    const response = await pca.handleRedirectPromise();

    if (response) {
      pca.setActiveAccount(response.account);
    }

    const root = ReactDOM.createRoot(document.getElementById("root")!);
    root.render(
      <MsalProvider instance={pca}>
        <Provider store={store}>
          <UserProvider>
            <ShareholderProvider>
             <App />
            </ShareholderProvider>
          </UserProvider>
        </Provider>
      </MsalProvider>
    );
  } catch (error) {
    console.error("Redirect or initialization error:", error);
  }
}

bootstrap();
